import { ReactNode } from 'react';

export interface InfoBarField {
    label: string;
    value: ReactNode;
}

/**
 * Bande d'information « En arrière plan » standardisée.
 * Affiche une liste de champs clé/valeur dans des pastilles colorées
 * qui s'adaptent au thème (clair/sombre) via les variables CSS.
 *
 * Exemple :
 *   <InfoBar data={[
 *     { label: 'Date Modif', value: record?.ModifDate },
 *     { label: 'Créé par', value: record?.CreatedBy },
 *   ]} />
 */
const InfoBar = (props: { data: InfoBarField[] }) => (
    <div className="eb-infobar">
        <legend className="eb-infobar-title">En arrière plan</legend>
        <hr className="eb-infobar-sep" />
        <div className="eb-infobar-row">
            {props.data.map((f, i) => (
                <div key={i} className="eb-infobar-item">
                    <span className="eb-infobar-label">{f.label}</span>
                    <span className="eb-infobar-value">{f.value ?? '—'}</span>
                </div>
            ))}
        </div>
    </div>
);

export default InfoBar;
